import React, { ReactNode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

/**
 * GoogleAuthProvider component
 * Wraps the application with Google OAuth context
 * Required for using Google Login features
 */
interface GoogleAuthProviderProps {
    children: ReactNode;
    clientId: string;
}

const GoogleAuthProvider: React.FC<GoogleAuthProviderProps> = ({ children, clientId }) => {
    // If clientId is missing, we still need to render the provider to prevent 
    // "useGoogleLogin must be used within GoogleOAuthProvider" errors.
    // We use a dummy ID and warn the user.
    const effectiveClientId = clientId || 'missing-client-id';

    if (!clientId) {
        console.warn('⚠️ Google Client ID is missing! Google Login will not function. Please set REACT_APP_GOOGLE_CLIENT_ID in your .env file and restart the server.');
    }

    return (
        <GoogleOAuthProvider clientId={effectiveClientId}>
            {children}
        </GoogleOAuthProvider>
    );
};

export default GoogleAuthProvider;
